import { dateIsWithinRange } from "@ch/helpers/utils/dates";
import moment from "moment";
import type { ChangeEventHandler, FC } from "react";
import TextInput, { type TextInputProps } from "./TextInput";

export type DateTimePickerProps = Omit<TextInputProps, "value" | "onChange"> & {
  maxDate?: string | Date;
  minDate?: string | Date;
  value?: string | Date;
  /**
   *
   * @param value The date in ISO format
   * @returns void
   */
  onChange?: (value: string) => void;
};

const DateTimePicker: FC<DateTimePickerProps> = ({
  maxDate,
  minDate,
  value,
  onChange,
  ...props
}) => {
  const localMaxDateToUse = maxDate
    ? moment.utc(maxDate).local().format("YYYY-MM-DDTHH:mm")
    : undefined;

  const localMinDateToUse = minDate
    ? moment.utc(minDate).local().format("YYYY-MM-DDTHH:mm")
    : undefined;

  const localDateTime = value
    ? moment.utc(value).local().format("YYYY-MM-DDTHH:mm")
    : "";

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const localDate = event.target.value;

    if (!localDate) {
      onChange?.("");
      return;
    }

    if (
      !dateIsWithinRange(
        moment(localDate),
        localMinDateToUse ? moment(localMinDateToUse) : undefined,
        localMaxDateToUse ? moment(localMaxDateToUse) : undefined,
      )
    ) {
      onChange?.("");
      return;
    }

    const utcDate = moment(localDate).toISOString();

    onChange?.(utcDate);
  };

  return (
    <TextInput
      max={localMaxDateToUse}
      min={localMinDateToUse}
      onChange={handleChange}
      placeholder="YYYY/MM/DD"
      type="datetime-local"
      value={localDateTime}
      {...props}
    />
  );
};

export default DateTimePicker;
